export default __webpack_public_path__ + "static/bg-dark-illustration-cc5043a4e7e3221fa4d0ba89eb2dd896.png";